export const CONFIG = {
  apiPrefix: '/api',

  gridPageSizes: [20, 50, 100],
  defaultPageSize: 20,
};
